export enum GraphArrowDirectionEnum {
  Up = "material-symbols:keyboard-arrow-up-rounded",
  Down = "material-symbols:keyboard-arrow-down-rounded",
  Maintain = "bi:dash",
}
